import {
    Building2, User
} from 'lucide-react';

export default {
    name: 'Main',
    list: [
        {
            name: 'Profile',
            path: '/profile',
            icon: <User className="h-5 w-5" />
        },
        {
            name: 'Organizations',
            path: '/organizations',
            icon: <Building2 className="h-5 w-5" />
        },
    ]
};